import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';

import CaseComposer from './CaseComposer';

/**
 * PublishCasePage — 案例发布独立页面（/publish-case）
 *
 * 中间内容区直接渲染现有 CaseComposer 组件（完整案例表单）。
 * 无 AI 元素、无浮层，表单在页面上填写提交。
 */
export default class PublishCasePage extends Page {
  title() {
    return '发布案例';
  }

  view() {
    if (!this.isAllowed()) {
      return (
        <div className="container">
          <div className="Alert Alert--warning" style={{ marginTop: 20 }}>
            <i className="fas fa-lock" /> 仅 S1 及以上等级用户可发布案例。
          </div>
        </div>
      );
    }
    return (
      <div className="PublishCasePage">
        <div className="container">
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16 }}>
            <i className="fas fa-pen-to-square" /> 发布案例
          </h2>
          <p style={{ color: '#666', fontSize: 13, marginBottom: 24 }}>
            填写案例信息。提交后案例将被创建为隐私帖子。
          </p>
          <CaseComposer />
        </div>
      </div>
    );
  }

  isAllowed() {
    const user = app.session.user;
    if (!user) return false;
    if (typeof user.isAdmin === 'function' && user.isAdmin()) return true;
    const level = (user.attribute && user.attribute('taroSwordLevel')) || 'S0';
    return level !== 'S0';
  }
}
